import { Outlet } from "react-router";

export function AuthLayout() {
  return (
    <main className="flex min-h-dvh items-center justify-center bg-background px-4 py-8 dark:bg-background">
      <div className="w-full max-w-[480px]">
        <Outlet />
      </div>
    </main>
  );
}
